var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 18,
    viewBox: "0 0 68 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1819_773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.25 8.25L18.25 1.5C18.8467 1.5 19.419 1.73705 19.841 2.15901C20.2629 2.58097 20.5 3.15326 20.5 3.75V6.75H24.745C24.9624 6.74754 25.1778 6.79238 25.3762 6.88141C25.5746 6.97045 25.7512 7.10155 25.8939 7.26564C26.0366 7.42972 26.1419 7.62287 26.2025 7.83169C26.2631 8.04051 26.2776 8.26002 26.245 8.475L25.21 15.225C25.1558 15.5827 24.9741 15.9087 24.6984 16.143C24.4228 16.3773 24.0717 16.5041 23.71 16.5H15.25M15.25 8.25V16.5M15.25 8.25H13C12.6022 8.25 12.2206 8.40804 11.9393 8.68934C11.658 8.97064 11.5 9.35218 11.5 9.75V15C11.5 15.3978 11.658 15.7794 11.9393 16.0607C12.2206 16.342 12.6022 16.5 13 16.5H15.25",
    stroke: "#1D7777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.012 9.75027L51.012 16.5003C50.4152 16.5003 49.843 16.2632 49.421 15.8413C48.999 15.4193 48.762 14.847 48.762 14.2503V11.2503H44.517C44.2996 11.2527 44.0842 11.2079 43.8858 11.1189C43.6874 11.0298 43.5108 10.8987 43.3681 10.7346C43.2254 10.5706 43.1201 10.3774 43.0595 10.1686C42.9989 9.95976 42.9844 9.74025 43.017 9.52527L44.052 2.77527C44.1062 2.41759 44.2879 2.09157 44.5636 1.85727C44.8392 1.62297 45.1902 1.49618 45.552 1.50027H54.012M54.012 9.75027V1.50027M54.012 9.75027H56.0145C56.439 9.75778 56.8514 9.60917 57.1735 9.33266C57.4957 9.05614 57.7051 8.67098 57.762 8.25027V3.00027C57.7051 2.57957 57.4957 2.1944 57.1735 1.91788C56.8514 1.64137 56.439 1.49276 56.0145 1.50027H54.012",
    stroke: "#1D7777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1819_773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeDislike);
export default __webpack_public_path__ + "static/media/like_dislike.999817414bf05062b5727e37def734b9.svg";
export { ForwardRef as ReactComponent };